// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/iconfont/iconfont'
import axios from 'axios'
import store from './store'
import Vuex from 'vuex'
import qs from 'qs'
import language from './utils/i18n.js'
import elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

axios.defaults.baseURL = '/api'
Vue.config.productionTip = false
Vue.prototype.$language = language
Vue.prototype.$store = store
Vue.use(router)
Vue.use(elementui)
Vue.use(qs)
Vue.use(Vuex)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js